import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

window.requestAnimationFrame = window.requestAnimationFrame.bind(window);
gsap.registerPlugin(ScrollTrigger);

var ContentHeadingWithText = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ContentHeadingWithText',
	};

	$.extend(true, this.options, options);

};

ContentHeadingWithText.prototype.init = function() {

	var self = this;

	PubSub.subscribe("ContentHeadingWithText.animateIn",function(){
		self.animateIn.play();
	});

	if (self.options.$el.prev().hasClass(`comp-HeroBackgroundVideo`))
	{
		this.initAnimateIn();
	}

};

ContentHeadingWithText.prototype.initAnimateIn = function(){

	var self = this;

	this.animateIn = gsap.timeline({ paused: true })
	.to(self.options.$el.find(`.${self.options.baseClass}__heading`),
		{
			y: 0,
			opacity: 1,
			duration: 0.8,
			ease: "power3.out"
		},
		0
	)
	.to(self.options.$el.find(`.${self.options.baseClass}__textContent`),
		{
			y: 0,
			opacity: 1,
			duration: 0.8,
			ease: "power3.out"
		},
		0.15
	)
	.to(self.options.$el.find(`.${self.options.baseClass}__textContent__line`),
		{
			width: "64%",
			duration: 1,
			ease: "power1.out"
		},
		0.15
	);

}

export default ContentHeadingWithText;
